module.exports = __webpack_public_path__ + "json/buildings-14.json?a32c1aaf4caf7ce6c9a85cac6a15cfd3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/packed/buildings/buildings-14.json
// module id = 1720
// module chunks = 3